import routerOptions0 from "/home/gitlab-runner/builds/52ykkrvhr/0/nationalhorseman/nationalhorseman-laravel-8/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}